(function() {
  'use strict';

  const HEADER_OFFSET = 98;
  const SELECTOR = '.js-smooth-scroll';
  let activeListeners = new Map();

  function initSmoothScroll() {
    activeListeners.forEach((handler, link) => {
      if (!link || !document.body || !document.body.contains(link)) {
        activeListeners.delete(link);
      }
    });
    
    const ctaLinks = document.querySelectorAll(SELECTOR);
    if (!ctaLinks || ctaLinks.length === 0) return;

    ctaLinks.forEach(link => {
      if (!link || typeof link.addEventListener !== 'function') return;
      
      if (activeListeners.has(link)) {
        const oldHandler = activeListeners.get(link);
        if (oldHandler && link && typeof link.removeEventListener === 'function') {
          link.removeEventListener('click', oldHandler);
        }
      }
      
      activeListeners.set(link, handleSmoothScroll);
      link.addEventListener('click', handleSmoothScroll);
    });
  }

  function cleanup() {
    activeListeners.forEach((handler, link) => {
      if (link && typeof link.removeEventListener === 'function' && handler) {
        link.removeEventListener('click', handler);
      }
    });
    activeListeners.clear();
  }

  function handleSmoothScroll(event) {
    const clickElement = event && event.currentTarget ? event.currentTarget : (event && event.target ? event.target : event);
    
    if (!clickElement || !(clickElement instanceof Element)) {
      return;
    }

    const anchor = clickElement.getAttribute('data-anchor');
    if (!anchor || anchor.trim() === '') {
      return;
    }

    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    let targetElement = document.getElementById(anchor);
    
    if (!targetElement) {
      try {
        const escapedAnchor = anchor.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
        targetElement = document.querySelector(`[data-section-id="${escapedAnchor}"]`);
      } catch (queryError) {
      }
    }
    if (!targetElement) {
      try {
        const escapedAnchor = CSS.escape ? CSS.escape(anchor) : anchor.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
        const anchorLink = document.querySelector(`#${escapedAnchor}`);
        if (anchorLink) {
          targetElement = anchorLink.closest('.shopify-section');
        }
      } catch (selectorError) {
      }
    }
    if (!targetElement) {
      return;
    }

    scrollToElement(targetElement);
  }

  function scrollToElement(element) {
    if (!element || typeof element.getBoundingClientRect !== 'function') return;

    try {
      const rect = element.getBoundingClientRect();
      const elementPosition = rect.top;
      const currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      
      const absoluteElementTop = elementPosition + currentScroll;
      const offsetPosition = absoluteElementTop - HEADER_OFFSET;
      const finalPosition = Math.max(0, offsetPosition);

      if (window.scrollTo) {
        window.scrollTo({
          top: finalPosition,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo(0, finalPosition);
      }
    } catch (error) {
      console.error('New Banner scroll error:', error);
    }
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSmoothScroll);
    } else {
      initSmoothScroll();
    }
  }

  init();

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSmoothScroll);
    document.addEventListener('shopify:section:unload', cleanup);
  }

  window.addEventListener('beforeunload', cleanup);
})();

